import React from 'react';
import { IsVisibleFunc } from 'ui-builder';
import Layout from './Layout';

export interface SeparatorWithTextProps {
  text: string;
  marginSize?: 'small' | 'medium' | 'big';
  // eslint-disable-next-line react/no-unused-prop-types
  isVisible?: boolean | IsVisibleFunc;
}

export function SeparatorWithText(props: SeparatorWithTextProps) {
  return (
    <Layout {...props} />
  );
}